<!--Mobile Nav-->
<fgb-page-header [pageTitle]="'wallet.page.title'" [showBalance]="false"></fgb-page-header>

<div class="container">
  <ng-container *ifScreenSize="screenSize.Desktop">
    <div class="page-padding">
      <a class="cursor-pointer wallet-back-button mb-3" [routerLink]="'/rewards/wallet'">
        <span class="icon material-icons text-white">arrow_back_ios</span>
      </a>
    </div>
  </ng-container>

  <fgbcl-lottos-wallet-details [lottoId]="id"></fgbcl-lottos-wallet-details>
</div>
